<mat-icon aria-hidden="true">search</mat-icon>
<input
  #input
  type="text"
  [attr.aria-label]="placeholder()"
  [placeholder]="placeholder()"
  [value]="text()"
  [disabled]="disabled()"
  (input)="onInput($event)"
  (blur)="touch.emit()" />
@if (text()) {
  <button
    type="button"
    class="clear"
    aria-label="Clear search"
    (click)="clear(input)">
    <mat-icon>close</mat-icon>
  </button>
}
